import notHandledHere from './notHandledHere';
import { database } from 'lib_ui-services';

export default {
    verb: 'doingCreate',
    excludedNamespaceRelations: [
        ...notHandledHere,
        { namespace: 'print', relation: 'job' },
        { namespace: 'metadata', relation: 'deployment' }
    ],
    description: 'Create the given record on the database',
    //this is the actual logic:
    logic
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function logic({ data, context }) {
    const db = database.get();
    const result = await db.insert(data, context);
    return { ...data, result };
}
